import { call, put, all } from "redux-saga/effects";
import { loadSongsSuccess, loadSongsFailure } from "../actions/songactions";
import { reportError } from "../actions/erroractions";
import { loadSongsAPI } from "../api/LoadSongsCalls";

export function* loadSongsSaga() {
  try {
    const result = yield call(loadSongsAPI);

    if (result.ok) {
      yield all([put(loadSongsSuccess(result.songList.songs))]); 
    } else {
      yield all([
        put(loadSongsFailure()),
        put(reportError("Unable to load songs")),
      ]);
    }
  } catch (e) {
    yield all([
      put(loadSongsFailure()),
      put(reportError("Unable to reach server")),
    ]);
  }
}
